module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "home-vp"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../../static/hotpages/promo-vale-pedagio/BGCaminhao_VP.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("Tenha vantagens com o Vale-pedágio Move Mais.")]), _vm._v(" "), _c('button', {
    attrs: {
      "aria-pressed": "true"
    },
    on: {
      "click": _vm.scroll
    }
  }, [_vm._v("Solicitar agora!")])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "nine-act"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "contact"
  }, [_c('h3', [_vm._v("#valepedagioeletronico")]), _vm._v(" "), _c('h1', [_vm._v("Para saber como adquirir o Vale-pedágio Move Mais, entre em contato:")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-2 col-md-8"
  }, [(_vm.formState == 'ERROR') ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible margin-t20 margin-b20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Erro!")]), _vm._v("\n                    " + _vm._s(_vm.errorMessage) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'LEAD-INFO') ? _c('div', {
    staticClass: "alert alert-info alert-dismissible margin-t20 margin-b20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Informação!")]), _vm._v("\n                  " + _vm._s(_vm.leadClient ? 'Caro cliente, sua solicitação encontra-se em análise. Em caso de dúvidas, por gentileza, entre em contato no número 08007651000' : 'Solicitação em análise. Em caso de dúvidas, por gentileza, entre em contato com o número 08007651000.') + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
    staticClass: "alert alert-success alert-dismissible margin-t20 margin-b20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v(" As informações foram enviadas, em breve entraremos em contato para finalizar a adesão, obrigado! ;)\n              ")]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "autocomplete": "false",
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doRequest.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('taxpayerIdNumber')
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label bold-600",
    attrs: {
      "for": "taxpayerIdNumber"
    }
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.taxpayerIdNumber),
      expression: "taxpayerIdNumber",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "mask-cnpj",
      rawName: "v-mask-cnpj"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cnpj'),
      expression: "'required|cnpj'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2})$",
      "name": "taxpayerIdNumber",
      "placeholder": "00.000.000/0000-00",
      "id": "taxpayerIdNumber",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.taxpayerIdNumber)
    },
    on: {
      "change": function($event) {
        _vm.taxpayerIdNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('taxpayerIdNumber')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('companyName')
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label bold-600",
    attrs: {
      "for": "companyName"
    }
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "companyName",
      "id": "companyName",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('companyName')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactName')
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label bold-600",
    attrs: {
      "for": "contactName",
      "required": ""
    }
  }, [_vm._v("Nome do Contato")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactName),
      expression: "contactName"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "contactName",
      "id": "contactName",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('contactName')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactEmail')
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label bold-600",
    attrs: {
      "for": "contactEmail"
    }
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactEmail),
      expression: "contactEmail"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "contactEmail",
      "id": "contactEmail",
      "placeholder": "Ex: nome@empresa.com",
      "data-vv-rules": "required|email|email:email"
    },
    domProps: {
      "value": (_vm.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('contactEmail')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactJobTitle')
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label bold-600",
    attrs: {
      "for": "contactJobTitle"
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.contactJobTitle),
      expression: "contactJobTitle",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "mask-tel",
      rawName: "v-mask-tel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|phone'),
      expression: "'required|phone'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "contactJobTitle",
      "id": "contactJobTitle"
    },
    domProps: {
      "value": (_vm.contactJobTitle)
    },
    on: {
      "change": function($event) {
        _vm.contactJobTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block with-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('contactJobTitle')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('sizeOfFleetVehicle')
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label bold-600",
    attrs: {
      "for": "sizeOfFleetVehicle"
    }
  }, [_vm._v("Tamanho da Frota")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sizeOfFleetVehicle),
      expression: "sizeOfFleetVehicle"
    }, {
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "only-numbers",
      rawName: "v-only-numbers"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "sizeOfFleetVehicle",
      "id": "sizeOfFleetVehicle",
      "data-vv-rules": "required|decimal|max:6",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.sizeOfFleetVehicle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sizeOfFleetVehicle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block-proposal help-block with-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('sizeOfFleetVehicle')))])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vp-info-box"
  }, [_c('div', [_c('img', {
    staticClass: "inline",
    attrs: {
      "src": require("../../../../static/hotpages/promo-vale-pedagio/c17.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "inline",
    attrs: {
      "src": require("../../../../static/hotpages/promo-vale-pedagio/c16.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h1', [_c('span', [_vm._v("\n                VALE-PEDÁGIO\n                "), _c('br')]), _vm._v("\n              ELETRÔNICO\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('strong', [_vm._v("\n              Bom para quem é Embarcador\n              "), _c('br'), _vm._v("e melhor ainda para quem é Transportador.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "second-act"
  }, [_c('div', [_c('div', [_c('img', {
    staticClass: "notebook",
    attrs: {
      "src": require("../../../../static/hotpages/promo-vale-pedagio/c14.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('p', [_vm._v("#valepedagioeletronico")]), _vm._v(" "), _c('h1', [_vm._v("Totalmente digital e fácil de usar")]), _vm._v(" "), _c('h2', [_vm._v("Você no controle total de sua frota.")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/hotpages/promo-vale-pedagio/c12.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Cobertura Nacional")]), _vm._v(" "), _c('p', [_vm._v("Estamos presentes em 100% dos Estados com vias pedagiadas, mais praticidade para suas viagens")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/hotpages/promo-vale-pedagio/c11.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Gestão Total")]), _vm._v(" "), _c('p', [_vm._v("Controle total da conta corrente, dados online das passagens e extrato detalhado das movimentações.")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/hotpages/promo-vale-pedagio/c10.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Integração")]), _vm._v(" "), _c('p', [_vm._v("Ferramenta de fácil integração via API, simplificando e otimizando custos nos processos de gerenciamento.")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/hotpages/promo-vale-pedagio/c9.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Inteligência & Tecnologia")]), _vm._v(" "), _c('p', [_vm._v("O sistema calcula automaticamente o valor dos pedágios de acordo com a rota definida e a quantidade de eixos.")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/hotpages/promo-vale-pedagio/c8.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Atendimento 24h")]), _vm._v(" "), _c('p', [_vm._v("Atendimento 24h por dia, 7 dias por semana, em vários canais.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container text-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "five-act"
  }, [_c('div', {
    staticClass: "counter"
  }, [_c('h1', {
    staticClass: "b1"
  }, [_vm._v("+")]), _vm._v(" "), _c('h1', {
    staticClass: "timer count-number b1",
    attrs: {
      "data-to": "65",
      "data-speed": "1500"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "count-text"
  }, [_vm._v("\n                Concessionárias\n                "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "linha-vertical"
  }), _vm._v(" "), _c('div', {
    staticClass: "counter"
  }, [_c('h1', {
    staticClass: "b2"
  }, [_vm._v("+")]), _vm._v(" "), _c('h1', {
    staticClass: "timer count-number b2",
    attrs: {
      "data-to": "370",
      "data-speed": "1500"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "count-text"
  }, [_vm._v("\n                Praças de\n                "), _c('br'), _vm._v("Pedágio\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "linha-vertical"
  }), _vm._v(" "), _c('div', {
    staticClass: "counter"
  }, [_c('h1', {
    staticClass: "b3"
  }, [_vm._v("+")]), _vm._v(" "), _c('h1', {
    staticClass: "timer count-number b3",
    attrs: {
      "data-to": "1600",
      "data-speed": "2000"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "count-text"
  }, [_vm._v("\n                Pistas para utilização\n                "), _c('br'), _vm._v("de TAG Move Mais\n              ")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "third-act"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "seven-act"
  }, [_c('h2', [_vm._v("#B2B")]), _vm._v(" "), _c('h1', [_vm._v("Planos Exclusivos para Empresas:")]), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {
    staticClass: "sixty-act"
  }, [_c('div', {
    staticClass: "color-box"
  }, [_c('div', {
    attrs: {
      "id": "box-orange"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "box-purple"
    }
  }, [_c('div', {}, [_c('h1', [_vm._v("Estradeiro")]), _vm._v(" "), _c('h3', [_vm._v("Pré-pago com recarga automática")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("- As recargas ocorrem automaticamente, quando o saldo atingir 30% do valor que o cliente escolher.")]), _vm._v(" "), _c('li', [_vm._v("- Sem taxa de mensalidade.")]), _vm._v(" "), _c('li', [_vm._v("- Saldo não expira. Sem caução.")]), _vm._v(" "), _c('li', [_vm._v("- Saldo compartilhado por todos os veículos.")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "box-blue"
    }
  }, [_c('div', {}, [_c('h1', [_vm._v("Frota")]), _vm._v(" "), _c('h3', [_vm._v("Pós-pago com mensalidade")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("- O cliente conta com uma linha de crédito para pagamento pós uso e a facilidade de prever o custo por meio de mensalidades fixas.")]), _vm._v(" "), _c('li', [_vm._v("- A fatura será emitida em prazos pré-definidos.")]), _vm._v(" "), _c('li', [_vm._v("- Sem custo de recarga.")])]), _vm._v(" "), _c('h6', [_vm._v("*sob análise de crédito")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "box-red"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "fourth-act"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('h1', {
    staticClass: "eight-act"
  }, [_vm._v("Vale-pedágio Eletrônico")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "privacyContainer"
    }
  }, [_c('span', {
    staticClass: "form-group",
    attrs: {
      "id": "spanPrivacyText"
    }
  }, [_vm._v(" Ao continuar você está de acordo com o nosso\n                      "), _c('a', {
    attrs: {
      "id": "spanPrivacyLink",
      "href": "/api/v2/archeion/downloadFileArcheion/aviso-de-privacidade-movemais",
      "target": "_blank"
    }
  }, [_vm._v("Aviso de Privacidade.\n                      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-offset-3 col-sm-6 pad-fix text-center"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-success bold-600 margin-30",
    attrs: {
      "id": "btn-enviar",
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("Solicitar proposta")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-c966caf6!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/promo/promo-toll-ticket.vue
// module id = 2214
// module chunks = 1